/**
 * @generated SignedSource<<dbc69a33f1b2954c99a43337897cb2af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useWidgetSignalSubscriptionArchivedSubscription$variables = {
  connections: ReadonlyArray<string>;
  teamIds: ReadonlyArray<string>;
};
export type useWidgetSignalSubscriptionArchivedSubscription$data = {
  readonly signalArchivedAtStore: {
    readonly id: string;
  } | null;
};
export type useWidgetSignalSubscriptionArchivedSubscription = {
  response: useWidgetSignalSubscriptionArchivedSubscription$data;
  variables: useWidgetSignalSubscriptionArchivedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetSignalSubscriptionArchivedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Signal",
        "kind": "LinkedField",
        "name": "signalArchivedAtStore",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWidgetSignalSubscriptionArchivedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Signal",
        "kind": "LinkedField",
        "name": "signalArchivedAtStore",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4aa1e63542010038adf2ee438f2cb3c",
    "id": null,
    "metadata": {},
    "name": "useWidgetSignalSubscriptionArchivedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetSignalSubscriptionArchivedSubscription(\n  $teamIds: [ID!]!\n) {\n  signalArchivedAtStore(teamIds: $teamIds) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c3231b186f77e393dad0e95337dfd18";

export default node;
